import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_SUBMIT_STATE } from '../../../constants/createSendSubmit';
import { ICreateSendSubmitState } from '../../../types/createSendSubmit';
import * as AuthActions from '../../actions/auth';
import * as SubmitActions from '../actions/submit';

export const initialState: ICreateSendSubmitState = DEFAULT_CREATE_SEND_SUBMIT_STATE;

const reducer = (state: ICreateSendSubmitState = initialState, action: any): ICreateSendSubmitState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case SubmitActions.CS_SUBMIT_REQUESTED: {
      return { ...state, isSubmitting: true, error: null };
    }
    case SubmitActions.CS_SUBMIT_SUCCESS: {
      return { ...state, isSubmitting: false, isCrmOpportunityPromptOpen: false };
    }
    case SubmitActions.CS_SUBMIT_FAILURE: {
      return {
        ...state,
        isSubmitting: false,
        error: action.payload && action.payload.error ? action.payload.error : action.payload,
        isCrmOpportunityPromptOpen: false,
      };
    }
    case SubmitActions.CS_RESET_SUBMIT_ERROR: {
      return { ...state, error: null };
    }
    case SubmitActions.CS_CRM_OPPORTUNITY_PROMPTED: {
      return { ...state, isCrmOpportunityPromptOpen: true };
    }
    case SubmitActions.CS_CRM_OPPORTUNITY_CHOSEN:
    case SubmitActions.CS_CRM_OPPORTUNITY_CANCELLED: {
      return { ...state, isCrmOpportunityPromptOpen: false };
    }
    default:
      return state;
  }
};

export default reducer;
